import {NotificationService} from "../../services/NotificationService";
import {MapSiteService} from "../../services/MapSiteService";
import {MapSite} from "../../entities/MapSite";

export class CmdCenterEditSiteModel {
    mapSite:MapSite;
    mapSiteID:number;
    static $inject = ['$q','MapSiteService','NotificationService'];
    constructor(public $q:ng.IQService,
                public mapSiteService:MapSiteService,
                public notificationService:NotificationService)
    {
    }

    init(mapSiteId:number):ng.IPromise<any> {
        this.mapSiteID = mapSiteId;
        var mainPromise:ng.IPromise<any> = null;
        if(isNaN(this.mapSiteID))
            mainPromise = this.$q.when<MapSite>(null);
        else
            mainPromise = this.mapSiteService.get(this.mapSiteID);
        return this.$q.all([mainPromise]).then((data:any)=> {
            this.mapSite = data[0] == null ? new MapSite() : data[0];
        });
    }
    save():ng.IPromise<any>{
        if(this.mapSite.name == null || this.mapSite.name.length == 0)
        {
            this.notificationService.notify("Please enter a name before saving");
            return this.$q.when<boolean>(false);
        }
        var mainPromise:ng.IPromise<any> = null;
        if(isNaN(this.mapSiteID))
            mainPromise = this.mapSiteService.insert(this.mapSite);
        else
          mainPromise = this.mapSiteService.update(this.mapSite);
        return mainPromise;
    }
}
